export default __webpack_public_path__ + "static/media/i-settings.821462f7.png";